import React, { useState } from 'react';
import Select from 'react-select';
import { useLocation } from 'react-router-dom';

const DateFilter = ({ handleFilterChange}) => {
    const today = new Date().toISOString().split('T')[0];
    console.log(window.location.pathname)
    // const formattedFromDate = new Date(new Date().setFullYear(new Date().getFullYear() - 1)).toISOString().split('T')[0];
    const [fromDate, setFromDate] = useState(today);
    const [toDate, setToDate] = useState(today);
    const [name, setName] = useState("");
 
    const displayDate = window.location.pathname == "/admin/farm/animal/health" ? false : true;
    const displayText = window.location.pathname == "/admin/farm/dashboard" || window.location.pathname == "/admin/construction/dashboard" || window.location.pathname == "/admin/agriculture/dashboard" || window.location.pathname == "/admin/account/list" ? false : true;
    
    const [filter, setFilter] = useState(false);
    const location = useLocation();
    const routeName = location.pathname.split('/').pop(); 
    
    const handleDateChange = (e) => {
        const {name, value} = e.target;
        if(name == "from_date"){
            setFromDate(value);
        }else if(name == "to_date"){
            setToDate(value);
        }else if(name == "name"){
            setName(value);
        }
        
    };

    const handleSubmit = () => {
        // Handle submit logic here
        // You can pass date and session values to the parent component using handleFilterChange
        handleFilterChange(fromDate, toDate, "", "", name);
        setFilter(true);
    };

    const handleClear = () => {
        handleFilterChange("", "", "clear", today, "");
        setFromDate(today);
        setToDate(today);
        setName("");
        setFilter(false);
    }
    

   

    return (
        <div className="flex flex-column sm:flex-row flex-wrap space-y-4 sm:space-y-0 items-center pb-4">
           
            {displayDate && <div className='m-5'>
                <input
                    type="date"
                    className="block p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="from_date"
                    onChange={handleDateChange}
                    value={fromDate}
                />
            </div>}
            {displayDate && <div className='m-5'>
                <input
                    type="date"
                    className="block p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="to_date"
                    onChange={handleDateChange}
                    value={toDate}
                />
            </div>}

            {displayText && <div className='m-5'>
                <input
                    type="text"
                    className="block p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="name"
                    placeholder='Search'
                    onChange={handleDateChange}
                    value={name}
                />
            </div>}
           
            
            <div className='m-5'>
                <button
                    onClick={handleSubmit}
                    className="px-4 py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200"
                >
                    Submit
                </button>
                {filter && 
                 <button
                 onClick={handleClear}
                 className="px-4 py-2 bg-blue-500 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200"
             >
                 Clear
             </button>}
            </div>
           
        </div>
    );
};

export {DateFilter};
